import link from '~/components/atoms/a-links/a-link-v2.data'
export default {
  menu_copy: 'Menu',
  logo: [
    {
      ...link,
      copy: 'Tribal Worldwide',
      href: {
        url: '/',
        cached_url: '/',
      },
    },
  ],
  links: [
    {
      ...link,
      copy: 'Work',
      href: {
        url: '/our-work',
        cached_url: '/our-work',
      },
    },
    {
      ...link,
      copy: 'About',
      href: {
        url: '/about-us',
        cached_url: '/about-us',
      },
    },
    {
      ...link,
      copy: 'Thinking',
      href: {
        url: '/practices',
        cached_url: '/practices',
      },
    },
    {
      ...link,
      copy: 'Events',
      href: {
        url: '/join-us',
        cached_url: '/join-us',
      },
    },
    {
      ...link,
      copy: 'News',
      href: {
        url: '/thinking',
        cached_url: '/thinking',
      },
    },
    {
      ...link,
      copy: 'Contact',
      href: {
        url: '/offices',
        cached_url: '/offices',
      },
    },
  ],
}
